import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { asyncRoutes, constantRoutes } from "@/router";
function normalizeContext(context) {
  if (Array.isArray(context)) {
    return {
      permissions: context,
      roleCode: null,
      teamMembers: []
    };
  }
  return {
    permissions: (context === null || context === void 0 ? void 0 : context.permissions) || [],
    roleCode: (context === null || context === void 0 ? void 0 : context.roleCode) || null,
    teamMembers: (context === null || context === void 0 ? void 0 : context.teamMembers) || []
  };
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(context, route) {
  var _route$meta;
  const {
    permissions,
    roleCode,
    teamMembers
  } = normalizeContext(context);
  let result = true;
  if (route.meta && route.meta.permissions) {
    result = permissions.some(permission => route.meta.permissions.includes(permission.code));
  }
  if (result && ((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.onlyLeaderForStaff) === true && roleCode === "staff" && (teamMembers !== null && teamMembers !== void 0 ? teamMembers : []).length <= 0) {
    return false;
  }
  return result;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param permissions
 */
export function filterAsyncRoutes(routes, context) {
  const res = [];
  routes.forEach(route => {
    const tmp = {
      ...route
    };
    if (hasPermission(context, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, context);
      }
      if (tmp.path === "/review" && !tmp.children.some(child => child.hidden !== true)) {
        return;
      }
      res.push(tmp);
    }
  });
  return res;
}
const state = {
  routes: [],
  addRoutes: []
};
const mutations = {
  SET_ROUTES: (State, routes) => {
    State.addRoutes = routes;
    State.routes = constantRoutes.concat(routes);
  }
};
const actions = {
  generateRoutes({
    commit
  }, context) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, context);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};